import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { ApprovalsService, DataService, UserService, OperationsService, LoansService } from '../../_services/index';
import { AuthenticationService, StorageService, AnalyticsService } from '../../_services/index';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';  

@Component({
  selector: 'app-wemapayments',
  templateUrl: './wemapayments.component.html',
  styleUrls: ['./wemapayments.component.css']
})
export class WemapaymentsComponent implements OnInit {

  loading = false;
  start_date = '2022-07-20';
  end_date = '2022-07-21';
  customers:any;
  currentUser:any;
  account_number = '';
  account_name = '';
  start = '0';
  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService, public loansService: LoansService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) {
   this.currentUser = this.storageService.read<any>('currentUser');
  }

  ngOnInit() {
    this.getCyberpayPayments(); 
  }
  getCyberpayPayments() {

    this.loading = true;
    this.loansService.getWemaPayments(this.start_date, this.end_date, this.currentUser.token, this.account_number, this.account_name, this.start)
      .subscribe(res => {
        this.loading = false;
        this.customers = res.records;
        this.start = res.start;
      });

  }

}
